import { combineReducers } from 'redux';
import * as reducers from './reducers';

export const errorsProcessing = combineReducers(reducers);
